export const SECTION_PADDING = 19;
